export const DEFAULT_RECURSIVE_FETCH_PARAMS: Record<string, unknown> = {
  page: 1,
  size: 100,
};
